import React from "react";

import { CharacterHandle } from "@components/character/character-lottie-web";
import ExerciseProgress from "@components/exercise-text-output/exercise-progress";
import ExerciseProgressMobile from "@components/exercise-text-output/exercise-progress-mobile";
import UnfocusedProgressOverlay from "@components/unfocused-progress/unfocused-progress-overlay";

import { spaceToUnicode } from "@helpers/helpers";

import { IGetExerciseEntrypointApiResponse } from "../../api/exercise-entrypoint/exercise-entrypoint.types";

type ExerciseTextOutputProps = {
  data: IGetExerciseEntrypointApiResponse | undefined;
  type: "desktop" | "mobile";
  text: string;
  currentLetterIndex: number;
  isOverlayVisible: boolean;
  isTooltipVisible: boolean;
  focusFunction: () => void;
  characterRef: React.MutableRefObject<null | CharacterHandle>;
};
function ExerciseTextOutput({
  data,
  type,
  text,
  currentLetterIndex,
  isOverlayVisible,
  isTooltipVisible,
  focusFunction,
  characterRef,
}: ExerciseTextOutputProps) {
  const overlayNode = (
    <UnfocusedProgressOverlay
      isVisible={isOverlayVisible}
      onButtonClick={focusFunction}
    />
  );

  const typedText = spaceToUnicode(text.slice(0, currentLetterIndex));
  const nextLetter = spaceToUnicode(text[currentLetterIndex] ?? "");
  const restText = spaceToUnicode(text.slice(currentLetterIndex + 1));

  return (
    <>
      {type === "desktop" && (
        <ExerciseProgress
          text={text}
          data={data}
          typedText={typedText}
          nextLetter={nextLetter}
          restText={restText}
          currentLetterIndex={currentLetterIndex}
          isOverlayVisible={isOverlayVisible}
          isTooltipVisible={isTooltipVisible}
          focusFunction={focusFunction}
          characterRef={characterRef}
          overlayNode={overlayNode}
        />
      )}
      {type === "mobile" && (
        <ExerciseProgressMobile
          typedText={typedText}
          nextLetter={nextLetter}
          restText={restText}
          currentLetterIndex={currentLetterIndex}
          characterRef={characterRef}
          focusFunction={focusFunction}
          overlayNode={overlayNode}
          isOverlayVisible={isOverlayVisible}
        />
      )}
    </>
  );
}

export default ExerciseTextOutput;
